import { render, staticRenderFns } from "./addrSelect.vue?vue&type=template&id=3478221d&"
import script from "./addrSelect.vue?vue&type=script&lang=js&"
export * from "./addrSelect.vue?vue&type=script&lang=js&"
import style0 from "./addrSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports